import WsProvider from './provider/WSProvider';

var serviceName = 'webservis';
var moduleName = 'personel';

var personelService = {
    imagePathBuyuk: WsProvider.imagePathBuyuk,
    imagePathOrta: WsProvider.imagePathOrta,
    imagePathKucuk: WsProvider.imagePathKucuk,
    imagePath: WsProvider.apiPath + 'belge/personel/resim/',
    filePath: WsProvider.apiPath + 'belge/personel/ozluk/',
    path: WsProvider.path,
    createPersonalInfoFiles({personelID, images, baslik, belge, updateID}) {
        try {
            var token = localStorage.getItem('userDataDemirag');
            var param = {
                token,
                [`data[${!updateID ? 'personelID' : 'ozlukID'}]`]: !updateID ? personelID : updateID,
                'data[baslik]': baslik,
                'belge': belge,
                methodName: !updateID ? 'OzlukEkle' : 'OzlukGuncelle',
                serviceName: moduleName,
            };
            if (images !== undefined && typeof images.forEach === 'function') {
                images.forEach((item, index) => (param[`resim[${index}]`] = item));
            }
            var result = new Promise(function (resolve, reject) {
                WsProvider.ajaxPost(serviceName, param)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
            return result;
        } catch (error) {
            console.log(error);
        }
    },
    createPersonalInfoImage({personelID, images}) {
        try {
            var token = localStorage.getItem('userDataDemirag');
            var param = {
                token,
                'data[personelID]': personelID,
                methodName: 'ResimEkle',
                serviceName: moduleName,
            };
            if (images !== undefined && typeof images.forEach === 'function') {
                images.forEach((item, index) => (param[`resim[${index}]`] = item));
            }
            var result = new Promise(function (resolve, reject) {
                WsProvider.ajaxPost(serviceName, param)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
            return result;
        } catch (error) {
            console.log(error);
        }
    },
    createPersonalInfoFileDetail({personelID, files, images}) {
        var token = localStorage.getItem('userDataDemirag');
        var param = {
            token,
            personelID,
            methodName: 'ozlukEkle',
            serviceName: moduleName,
        };

        if (typeof files.forEach === 'function') {
            files.forEach((item, index) => (param[`belge[${index}]`] = item));
        }

        if (typeof images.forEach === 'function') {
            images.forEach((item, index) => (param[`resim[${index}]`] = item));
        }

        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    personelOzlukList(durum = 1, baslangic = 0, limit = 20) {
        var token = localStorage.getItem('userDataDemirag');
        var param = {
            token,
            'data[baslangic]': baslangic,
            'data[durum]': durum,
            'data[limit]': limit,
            methodName: 'Listele',
            serviceName: moduleName,
        };

        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    getPersonalDetail({personelID}) {
        var token = localStorage.getItem('userDataDemirag');
        var param = {
            token,
            'data[personelID]': personelID,
            methodName: 'OzlukDetay',
            serviceName: moduleName,
        };

        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    personelResimSil(id) {
        var token = localStorage.getItem('userDataDemirag');
        var param = {
            token,
            'data[id]': id,
            methodName: 'ResimSil',
            serviceName: moduleName,
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    personelOzlukSil(id, evrakID) {
        var token = localStorage.getItem('userDataDemirag');
        var param = {
            token,
            'data[ozlukID]': id,
            methodName: 'OzlukSil',
            serviceName: moduleName,
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
};
export default personelService;
